export const loyaltyConstants = {
    ADD_MEMBER_REQUEST: "ADD_MEMBER_REQUEST",
    ADD_MEMBER_SUCCESS: "ADD_MEMBER_SUCCESS",
    ADD_MEMBER_FAILURE: "ADD_MEMBER_FAILURE",
    REFERENCES_LIST_REQUEST: "REFERENCES_LIST_REQUEST",
    REFERENCES_LIST_SUCCESS: "REFERENCES_LIST_SUCCESS",
    LOYALTY_RULES: "LOYALTY_RULES",
    LOYALTY_ERROR: "LOYALTY_ERROR",
    CLEAR_SUCCESS_MESSAGE: "CLEAR_SUCCESS_MESSAGE"
  };
  